var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockquote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 96,
    viewBox: "0 0 132 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4 96C50.6 96 61.6 88.6 66.6 76.4C72 88.6 83.8 96 97.8 96C118.2 96 131.4 82 131.4 62.8C131.4 45.6 119.2 31.6 101.8 31.6C93.2 31.6 84.8 34.4 82.6 37.2C82.6 33.4 85.2 28.6 90.2 22.8C100 11.4 120.8 5.59999 131 5.59999L127 -1.00136e-05C96.2 -1.00136e-05 69.8 18.2 63.8 44.8C58.2 36 50 31.6 39.4 31.6C30.8 31.6 22.4 34.4 20.2 37.2C20.2 33.4 22.8 28.6 27.8 22.8C37.6 11.4 58.4 5.59999 68.6 5.59999L64.6 -1.00136e-05C53.4 -1.00136e-05 42.4 2.59999 32.2 7.59999C11.6 17.8 0.200001 35.4 0.200001 56C0.200001 81.8 15.4 96 35.4 96Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockquote);
export default __webpack_public_path__ + "static/media/blockquote.f8d50ddd1d5a0d9774e1e9f42c8d1730.svg";
export { ForwardRef as ReactComponent };